import React from 'react';
import {withTranslation} from 'react-i18next';
import {
    EncCheckboxField,
    EncForm,
    EncInputField,
    EncRadioField,
    EncSelectField,
    withEncFormHandler
} from '../../../../../../../../../components/hocs/form-validation/index';

const FACTSET_CONNECTION_ALLOWED = 'Username-Password-Authentication';

let AddAccountUser = (props) => {
    const {formProperties, fieldProperties, t} = props;
    const connInfo = props.connectionInfo ? props.connectionInfo.find(conn => conn.name === fieldProperties.values.connection) : {};
    const isMtls = fieldProperties.values.authenticationType === 'mtls';

    if (connInfo.name !== FACTSET_CONNECTION_ALLOWED && fieldProperties.values.factsetAccessAllowed) {
        props.setFieldValue('factsetAccessAllowed', false);
    }

    if (isMtls) {
        if (fieldProperties.values.accountAdmin) {
            props.setFieldValue('accountAdmin', false);
        }
        if (fieldProperties.values.uiAccessAllowed) {
            props.setFieldValue('uiAccessAllowed', false);
        }
        if (!fieldProperties.values.apiAccessAllowed) {
            props.setFieldValue('apiAccessAllowed', true);
        }
        if (fieldProperties.values.factsetAccessAllowed) {
            props.setFieldValue('factsetAccessAllowed', false);
        }
    }

    return (
        <EncForm formProperties={formProperties} fieldProperties={fieldProperties}>
            <div className="radio__group" style={{marginBottom: '1.4rem'}}>
                <label>{t('user:user.authentication.type')}</label>
                <EncRadioField
                    id="authenticationType"
                    label="user:user.authentication.type.auth0"
                    value={'auth0'}
                />
                <EncRadioField
                    id="authenticationType"
                    label="user:user.authentication.type.mtls"
                    value={'mtls'}
                />
            </div>
            <EncInputField
                id="firstName"
                label="user:user.firstName"
            />
            <EncInputField
                id="lastName"
                label="user:user.lastName"
            />
            <EncInputField
                id="partnerUserId"
                label={"user:user.username"}
                validator={{
                    type: 'string',
                    rules: ['required', 'email']
                }}
            />
            {!isMtls && connInfo.strategy === 'auth0' &&
                <EncInputField
                    id="password"
                    type="password"
                    label="user:user.password"
                    validator={{
                        type: 'string',
                        passwordMinLength: connInfo.passwordMinLength,
                        passwordPolicy: connInfo.passwordPolicy,
                        rules: ['required', 'auth0Password']
                    }}
                />
            }
            {!isMtls &&
                <EncSelectField
                    id="connection"
                    label="user:user.connection"
                    options={props.connectionOptions}
                    validator={{
                        type: 'string',
                        rules: ['required']
                    }}
                />
            }
            <EncCheckboxField
                id="active"
                label="user:user.active"
                disabled={props.disableActive}
            />
            {!isMtls &&
                <EncCheckboxField
                    id="accountAdmin"
                    label="user:user.account.admin"
                />
            }
            {!isMtls &&
                <EncCheckboxField
                    id="uiAccessAllowed"
                    label="user:user.ui.access"
                />
            }
            {!isMtls &&
                <EncCheckboxField
                    id="apiAccessAllowed"
                    label="user:user.api.access"
                />
            }
            {!isMtls && connInfo.name === FACTSET_CONNECTION_ALLOWED &&
                <EncCheckboxField
                    id="factsetAccessAllowed"
                    label="user:user.factset.access"
                />
            }
        </EncForm>
    );
};

const FORM_VALIDATION_OPTIONS = {
    header: 'user:user.add.user',
    successMessage: 'user:user.user.successfully.created',
    validateOnChange: true,
    validateOnBlur: true,
    confirmAlertMsg: (initialValues, submitValues) => {
        if (submitValues.active === false) {
            return {
                header: 'user:user.confirm.add.user',
                messages: 'user:user.user.inactive.confirm.message'
            }
        }

        return undefined;
    }
};

AddAccountUser = withTranslation()(AddAccountUser);

export default withEncFormHandler(FORM_VALIDATION_OPTIONS)(AddAccountUser);